// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"297":"b8bf52f3","435":"94a2c7df","509":"b1145745"}[chunkId] + ".chunk.css";
};